import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult } from '@tanstack/react-query'
import { usePortalMutation } from 'src/Libs/api'
import { generatePartnerNumber } from '../api'

interface UseGeneratePartnerNumberParams {
  onSuccess?: (data: number | null) => void
  onError?: () => void
}

interface UseGeneratePartnerNumberProps {
  id: number
}

type UseGeneratePartnerNumberReturnType = (
  data: UseGeneratePartnerNumberParams
) => UseMutationResult<number | null, unknown, UseGeneratePartnerNumberProps>

/**
 * Hook for generating a partner number for a given company
 */
export const useGeneratePartnerNumber: UseGeneratePartnerNumberReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  const updatePartnerNumber = usePortalMutation({
    mutationFn: (props: UseGeneratePartnerNumberProps) => generatePartnerNumber(props.id, authFetch),
    onSuccess: data => {
      onSuccess?.(data)
    },
    onError: () => onError?.(),
  })

  return updatePartnerNumber
}
